import { COUPON_CODE, COUPON_DAYS_EXPIRE_DEFAULT } from "constants/cookies";
import { setCookie } from "services/cookies-service";
export const saveCouponCookie = (coupon = {})=>{
    coupon.code && setCookie(COUPON_CODE, coupon.code, {
        expires: parseInt(coupon.daysToExpire) || COUPON_DAYS_EXPIRE_DEFAULT
    });
};
